import {KTCard, KTCardBody} from "../../../../_websoft/helpers";
import {ToastContainer} from "react-toastify";
import React from "react";

const PrijavaKvaraTerminal:React.FC = () => {
    return (
        <KTCard>
            <ToastContainer />
            <KTCardBody className='py-4'>
                <div className="row">
                    <div className="col-xl-4 mt-2">
                        <a href="prijave" className="card bg-black hoverable card-xl-stretch mb-xl-8">
                            <div className="card-body"><i className="ki-duotone ki-element-11 text-white fs-3x ms-n1"><span
                                className="path1"></span><span className="path2"></span><span className="path3"></span><span
                                className="path4"></span></i>
                                <div className="text-white fw-bold fs-2 mb-2 mt-5">Pregled prijava</div>
                                <div className="fw-semibold text-white">Preuzmi prijavu, kreiraj intervenciju</div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-4 mt-2">
                        <a href="intervencije" className="card bg-black hoverable card-xl-stretch mb-xl-8">
                            <div className="card-body"><i className="ki-duotone ki-element-11 text-white fs-3x ms-n1"><span
                                className="path1"></span><span className="path2"></span><span className="path3"></span><span
                                className="path4"></span></i>
                                <div className="text-white fw-bold fs-2 mb-2 mt-5">Pregled intervencija za sredstvo</div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-4 mt-2">
                        <a href="moje-intervencije" className="card bg-black hoverable card-xl-stretch mb-xl-8">
                            <div className="card-body"><i className="ki-duotone ki-element-11 text-white fs-3x ms-n1"><span
                                className="path1"></span><span className="path2"></span><span className="path3"></span><span
                                className="path4"></span></i>
                                <div className="text-white fw-bold fs-2 mb-2 mt-5">Moje intervencije</div>
                            </div>
                        </a>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}
export default PrijavaKvaraTerminal;
